import { IconProps } from '../types'

const ChangeCareers = (props: IconProps) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
      fill="currentColor"
    />
    <g clipPath="url(#clip0_1896_60731)">
      <path
        d="M14.2735 36.6918C14.3042 34.7943 13.9586 32.1977 13.9904 30.3001C15.8459 30.1673 17.2912 30.1334 19.1468 30.0005L19.4299 26.1056C21.6619 25.9728 23.2795 25.839 25.5125 25.7062C25.6383 24.1748 25.7641 22.6435 25.89 21.1122C28.0286 21.245 30.5058 21.279 32.6424 21.4118C32.8312 26.3723 32.9666 31.3318 33.1553 36.2923C27.6512 36.4251 24.6499 36.7587 19.1468 36.8915C17.9825 36.6588 15.4366 36.9245 14.2735 36.6918Z"
        fill="white"
      />
      <path
        d="M29.2045 17.1803C31.1556 17.1803 32.7372 15.6403 32.7372 13.7408C32.7372 11.8412 31.1556 10.3013 29.2045 10.3013C27.2535 10.3013 25.6719 11.8412 25.6719 13.7408C25.6719 15.6403 27.2535 17.1803 29.2045 17.1803Z"
        fill="white"
      />
      <path
        d="M32.5916 26.605C31.8735 26.605 31.7976 27.4039 31.8223 28.103C31.8643 29.3014 31.6304 33.8075 31.6397 35.6271C29.0897 35.7929 26.7889 36.1554 24.2861 36.0925C21.69 36.0266 18.4609 35.8988 15.1191 35.772C15.0996 35.0349 15.0165 34.1601 15.0042 33.2333C14.998 32.5971 14.9909 31.948 14.9857 31.3617L19.3256 31.168C19.8601 31.149 20.2827 30.6856 20.2827 30.1204V26.5301H25.1713C25.7191 26.5301 26.3622 26.0607 26.3622 25.4814V22.1808C27.3059 22.1109 27.388 21.991 28.3019 22.011C28.8671 22.023 30.3954 22.2107 31.7197 22.2107C31.9248 22.2107 31.6869 23.0476 31.8223 23.7088C31.9248 24.2081 32.2736 24.8283 32.7454 24.8073C33.1434 24.7893 33.8737 24.4078 33.8737 23.4092C33.8737 22.4694 34.284 20.3132 32.4131 20.1924C31.0253 20.1025 29.6785 19.9417 28.3963 19.9137C27.1141 19.8858 26.4566 20.0136 25.1713 20.0775C24.8991 20.0937 24.6439 20.212 24.4593 20.4075C24.2747 20.6031 24.1752 20.8606 24.1815 21.1261V24.4328H19.2918C18.7451 24.4328 18.3009 24.9022 18.3009 25.4814V29.1067L13.9928 29.1017C13.4594 29.1217 13.002 29.7838 13.002 30.3491C13.002 31.138 13.0143 32.2156 13.0255 33.2582C13.0368 34.3009 13.1476 36.6808 13.1527 36.8196C13.1543 37.0845 13.2627 37.3383 13.4546 37.5262C13.6464 37.7141 13.9064 37.8211 14.1785 37.8243C16.8875 37.7903 21.2561 37.9181 24.0953 37.99C25.8904 38.035 27.19 37.9311 29.1492 37.7903C30.217 37.7903 31.1145 37.6904 32.1238 37.6904C33.4573 37.6904 33.8573 36.8505 33.8625 36.2923C33.8819 34.2839 34.0512 32.0978 33.9732 29.5012C33.9312 28.093 33.9373 28.7561 33.8707 27.7035C33.8317 27.0753 33.4634 26.605 32.5916 26.605Z"
        fill="#1E2532"
      />
      <path
        d="M29.155 18.0162C26.6019 18.0162 24.334 16.0408 24.334 13.555C24.334 11.0693 26.6019 9 29.155 9C31.708 9 33.976 10.9764 33.976 13.4622C33.976 15.9479 31.708 18.0162 29.155 18.0162ZM29.155 10.9524C27.7076 10.9524 26.2429 12.1449 26.2429 13.555C26.2429 14.9652 27.2932 16.2515 29.1068 16.2515C30.5551 16.2515 31.7798 14.9182 31.7798 13.5091C31.7793 12.8314 31.5026 12.1815 31.0105 11.7022C30.5184 11.2229 29.8511 10.9532 29.155 10.9524Z"
        fill="#1E2532"
      />
    </g>
    <defs>
      <clipPath id="clip0_1896_60731">
        <rect width="21" height="29" fill="white" transform="translate(13 9)" />
      </clipPath>
    </defs>
  </svg>
)

export default ChangeCareers
